
import IndustrySingle from "../../components/layouts/IndustrySingle.vue";

import HeroFull from "../../components/industries/HeroFull.vue";
import FormSection from "../../components/industries/FormSection.vue";
import RowSection from "../../components/industries/RowSection.vue";
import IconsGrid from "../../components/industries/IconsGrid.vue";
import TablesSection from "../../components/industries/TablesSection.vue";
import ContactInfo from "../../components/industries/ContactInfo.vue";

export default {
  components: {
    IndustrySingle,
    HeroFull,
    FormSection,
    RowSection,
    IconsGrid,
    TablesSection,
    ContactInfo,
  },
  data() {
    return {
      gridItems: [
        {
          graphic: "coins.svg",
          title: "Rates starting as low as 8.5%",
          text: "Great Fixed-Interest Rates for many industries",
        },
        {
          graphic: "calendar.svg",
          title: "Terms from 12 - 84 months",
          text: "Flexible repayment terms. Choose what works best for your needs.",
        },
        {
          graphic: "cash.svg",
          title: "Loans from $10K - $10M",
          text: "Different loan amounts for business different needs.",
        },
        {
          graphic: "mobile.svg",
          title: "Fully Digital Application",
          text: "Fast & simple online application. Quick approval decision.",
        },
        {
          graphic: "house.svg",
          title: "Possible funding in just 48 hours",
          text: "Once approved, your funds are immediately sent to your bank.",
        },
        {
          graphic: "247.svg",
          title: "Apply anytime 24/7",
          text: "Apply from home anytime. Never drive to a bank again.",
        },
      ],
      tableItems: [
        {
          title: "Working Capital",
          rows: [
            {
              title: "Credit Score",
              value: "580 FICO Score",
            },
            {
              title: "Revenue",
              value: "$15K a month / $180K a year",
            },
            {
              title: "Time in Business",
              value: "1-2 years",
            },
          ],
        },
        {
          title: "Equipment Financing",
          rows: [
            {
              title: "Credit Score",
              value: "625 FICO Score",
            },
            {
              title: "Revenue",
              value: "$15K a month / $180K a year",
            },
            {
              title: "Time in Business",
              value: "1-2 years",
            },
          ],
        },
      ],
    };
  },
  computed: {
    hasSecondRow() {
      return this.$slots["second-row"];
    },
  },
  mounted() {
  },
  head() {
    return {
      title: 'Commercial Truck Financing | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'American Credit offers immediate commercial truck financing to business owners just like you. Long haul, short haul & more. Contact our loan experts today!'
        }
      ]
    }
  }
};
